export default defineNuxtPlugin({
   name: 'acquisition-entry',
   enforce: 'pre',
   setup() {
      const entry = new URL(window.location.href);
      const acquisition = useAcquisition();
      const serializedAttribution = entry.searchParams.get('tt_attribution');
      let imported: Parameters<typeof acquisition.importAttribution>[0];
      if (serializedAttribution && new TextEncoder().encode(serializedAttribution).length <= 4096) {
         try {
            const parsed: unknown = JSON.parse(serializedAttribution);
            if (parsed && typeof parsed === 'object' && !Array.isArray(parsed) && ('first_touch' in parsed || 'last_touch' in parsed)) {
               imported = parsed as Parameters<typeof acquisition.importAttribution>[0];
            }
         } catch { /* Invalid campaign data cannot block signup. */ }
      }
      const visit = new URL(entry);
      if (imported) {
         for (const key of [...visit.searchParams.keys()]) {
            if (key.startsWith('utm_') || ['gclid', 'gbraid', 'wbraid', 'fbclid'].includes(key)) visit.searchParams.delete(key);
         }
      }
      acquisition.captureVisit(visit, document.referrer);
      if (imported) acquisition.importAttribution(imported);
      const token = entry.searchParams.get('redemption_token');
      if (entry.searchParams.has('redemption_token')) {
         useState<string | null>('redemption-entry-token', () => null).value = token || null;
         entry.searchParams.delete('redemption_token');
      }
      if (serializedAttribution !== null) entry.searchParams.delete('tt_attribution');
      if (token !== null || serializedAttribution !== null) {
         window.history.replaceState(window.history.state, '', `${entry.pathname}${entry.search}${entry.hash}`);
      }
   },
});
